<template>
  <div>
    <div class="container">
      <template v-for="(row, index) in payments">
        <div class="row row-list" :key="'r' + index">
          <div class="col-10 order-first col-md-5">
            <select-input v-model="row.payment_method" :alias="'Parcela ' + (index + 1)" :placeholder="'Forma de Pg'"
              :options="paymentOptions[operation]" />
          </div>
          <div class="col-10 order-3 order-md-2 col-md-5">
            <number-input v-model="row.value" :minimumValue="-999999999" :alias="'Valor'"
              :placeholder="'Valor'"></number-input>
          </div>
          <div class="col-2 order-2 order-md-3 col-md-2">
            <div class="form-group">
              <label class="control-label">&nbsp;</label>
              <br />
              <button v-if="canDeleteRow" class="btn btn btn-light" @click="removePaymentRow(index)">
                <i class="text-info fas fa-times"></i>
              </button>
            </div>
          </div>
          <template v-if="showCreditCardBrand(row.payment_method)">
            <div class="col-3 col-md-5 order-4">
              <select-input v-model="row.credit_card_brand" :alias="'Bandeira do Cartão'" :options="creditCardBrands" />
            </div>
            <div class="col-3 col-md-5 order-5">
              <text-input v-model="row.credit_card_authorization_code" :alias="'N. Autorização'" />
            </div>
            <div class="col-3 col-md-5 order-6">
              <text-input v-model="row.credit_card_operator_cnpj" :alias="'Cnpj Credenciadora.'" />
            </div>
          </template>
          <template v-if="haveDueTo(row.payment_method)">
            <div class="col-4 col-md-5 order-4">
              <number-input v-model="row.due_days" :alias="'Prazo (dias)'" @input="calcDate(index)" :decimal-places="0"
                :minimumValue="-999999999"></number-input>
            </div>
            <div class="col-6 col-md-5 order-5">
              <date-input v-model="row.due_date" :alias="'Vencimento'" @input="calcDays(index)"></date-input>
            </div>
          </template>
        </div>
      </template>

      <div class="row">
        <div class="col-md-6">
          <button class="btn btn-link text-info" @click="addPaymentRow">
            <i class="fas fa-plus" /> Adicionar parcela
          </button>
        </div>
        <div class="col-md-6 text-md-right" v-if="payments.length > 1">
          <button class="btn btn-link text-info" @click="dividePayments">
            <i class="fas fa-divide" /> Calcular parcelas
          </button>
        </div>
      </div>
      <br />
      <div class="row" v-if="!isPaymentsEqualsToOrderTotal">
        <div class="col-12">
          <b-alert :show="!isPaymentsEqualsToOrderTotal" variant="danger">
            Total das parcelas ( {{ paymentsTotal | decimal }} ) diferente do
            total da venda ( {{ orderTotal | decimal }} ).
          </b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters";
import moment from "moment";

export default {
  props: {
    value: {},
    operation: {
      default: 1
    },
    orderTotal: {},
  },

  data: function () {
    return {
      formChanged: false,

      paymentOptions: {
        1: {
          1: "Dinheiro",

          // @celso: comentado por estar em testes
          2: "Cheque",

          3: "Cartão de Crédito",

          4: "Cartão de Débito",

          5: "Crédito Loja",

          15: "Boleto Bancário",

          16: "Deposito Bancário",

          17: 'PIX',

          18: 'Carteira Digital',


          // 18: "Carteira digital (PICPAY)",

          // 19: "Programa de fidelidade, Cashback, Crédito Virtual",

          // 98: "Regime Especial NFF",

          99: "Outros"
        },

        2: {
          1: "Devolução de dinheiro",

          5: "Crédito Loja",
        },
      },

      payments: [
        {
          payment_method: 1,
          value: null,
          due_days: 30,
          due_date: moment().add(30, "d").format("YYYY-MM-DD"),
          credit_card_brand: null,
          credit_card_operator_cnpj: null,
          credit_card_authorization_code: null,
        },
      ],

      basePayment: {
        payment_method: 1,
        value: null,
        due_days: 30,
        due_date: moment().add(30, "d").format("YYYY-MM-DD"),
        credit_card_brand: null,
        credit_card_operator_cnpj: null,
        credit_card_authorization_code: null,
      },

      creditCardBrands: {
        '01': 'Visa',
        '02': 'Mastercard',
        '03': 'American Express',
        '04': 'Sorocred',
        '05': 'Diners Club',
        '06': 'Elo',
        '07': 'Hipercard',
        '08': 'Aura',
        '09': 'Cabal',
        '99': 'Outros',
      }
    };
  },

  watch: {
    value: function (val) {
      this.setPayments(val);
    },

    orderTotal: function (val) {
      if (this.payments.length == 1) {
        this.payments[0].value = val;
      }
    },

    payments: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },

  computed: {
    paymentsCount() {
      return this.payments.length;
    },

    paymentsTotal() {
      var sum = 0;

      for (let index in this.payments) {
        sum += this.payments[index].value;
      }

      return Math.round(sum * 100) / 100;
    },

    isPaymentsEqualsToOrderTotal() {
      return this.paymentsTotal == this.orderTotal;
    },

    canDeleteRow() {
      return this.payments.length > 1;
    },
  },

  methods: {
    setPayments(value) {
      this.payments = value;
    },

    addPaymentRow() {
      let due_days = this.getNextPaymentDays();
      let payment_method = this.getNextPaymentMethod();

      this.payments.push({
        payment_method: payment_method,
        value: 0,
        due_days: due_days,
        due_date: moment().add(due_days, "d").format("YYYY-MM-DD"),
      });
    },

    getNextPaymentDays() {
      let lastPayment = this.payments[this.payments.length - 1];

      if (lastPayment.payment_method != 5) {
        return 30;
      }

      return lastPayment.due_days + 30;
    },

    getNextPaymentMethod() {
      let lastPayment = this.payments[this.payments.length - 1];

      if (lastPayment.payment_method == 1) {
        return 5;
      }

      return lastPayment.payment_method;
    },

    removePaymentRow(index) {
      this.$delete(this.payments, index);
    },

    dividePayments() {
      var parcel =
        Math.round((this.orderTotal / this.paymentsCount) * 100) / 100;
      var remainder =
        Math.round((this.orderTotal - parcel * this.paymentsCount) * 100) / 100;

      this.payments[0].value = parcel + remainder;

      for (var i = 1; i < this.paymentsCount; i++) {
        this.payments[i].value = parcel;
      }
    },

    haveDueTo(payment_method) {
      if (this.operation !== 1) {
        return false;
      }

      return payment_method == 5 || payment_method == 15;
    },

    showCreditCardBrand(payment_method) {
      if (this.operation !== 1 || this.$store.state.auth.user.company.module_nfe_active !== 1) {
        return false;
      }

      return (payment_method == 3 || payment_method == 4);
    },

    calcDate(index) {
      this.payments[index].due_date = moment()
        .add(this.payments[index].due_days, "d")
        .format("YYYY-MM-DD");
    },

    calcDays(index) {
      var due_date = moment(this.payments[index].due_date, "YYYY-MM-DD");

      this.payments[index].due_days = due_date.diff(moment(), "d") - 1;
    },
  },
};
</script>

<style>
.row-list {
  padding-top: 1rem;
  /*border-top: dashed 1px gray;*/
  border-bottom: dashed 1px rgba(0, 0, 0, 0.125);
}

.row-list-first {
  padding-top: 1rem;
  /*border-top: dashed 1px rgba(0, 0, 0, 0.125);*/
  border-top: dashed 1px rgba(0, 0, 0, 0.125);
}
</style>